<template>
  <div class="list-container">
    <ul class="nav nav-tabs">
      <li class="tabBtn be_usable" v-bind:class="{ active: type === 1 }">
        <a href="javascript: void(0)" @click="changeTab(1)"
          >可使用<i v-if="preCanUseCoupons.length > 0" class="canUseCount">{{
            preCanUseCoupons.length
          }}</i></a
        >
      </li>
      <li class="tabBtn used" v-bind:class="{ active: type === 2 }">
        <a href="javascript: void(0)" @click="changeTab(2)">已使用</a>
      </li>
      <li class="tabBtn expired" v-bind:class="{ active: type === 3 }">
        <a href="javascript: void(0)" @click="changeTab(3)">已过期</a>
      </li>
    </ul>
    <div class="tab-content">
      <!--可使用-->
      <div
        class="tab-pane coupon_modal_bd"
        v-bind:class="{ active: type === 1 }"
      >
        <!---优惠券列表-->
        <ul v-if="preCanUseCoupons.length > 0" class="row coupon__useSuccess">
          <li
            v-for="item in canUseCoupons"
            :key="item.id"
            class="col-lg-6 col-sm-6 col-md-6 col-xs-6 be_usable_status"
          >
            <div class="coupon_box fix">
              <div class="f-fl">
                <div class="left_box">
                  <div class="coupon_anchor">
                    <img
                      src="https://resource.rcclchina.com.cn/tui2/user_center/anchor.png"
                    />
                  </div>
                  <div class="coupon_title">
                    {{ item.promotion }}
                    <span class="price"></span>
                  </div>
                  <div v-if="item.createdTime" class="coupon_date">
                    {{item.createdTime}}
                  </div>
                  <div class="coupon_date">
                    {{item.expirationTime}}
                  </div>
                  <div class="coupon_info">
                    <span role="button" @click="showCouponLayer(item.rule)"
                      >使用规则</span
                    >
                    券编号:&nbsp;{{ item.token }}
                  </div>
                </div>
              </div>
              <div class="f-fl">
                <div class="right_box">
                  <a :href="item.skipUrl">
                    <i class="coupon_status"></i>
                  </a>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <!--内容为空提示-->
        <div v-else class="isnull_tips">
          <img src="../../assets/no_coupon_ico.png" alt="" />
          好可惜，这里空空如也~<br />
          您目前没有可用优惠券呦！<br />
          <router-link to="/Rccl.Cruise/CruiseSearch/Search" class="go_next_btn"
            >马上去看看</router-link
          >
        </div>

        <!-- 选择心仪路线 -->
        <div v-if="preCanUseCoupons.length > 0" class="booking_now">
          <router-link to="/Rccl.Cruise/CruiseSearch/Search"
            >立即预订心仪航线&gt;</router-link
          >
        </div>
      </div>
      <!--已使用-->
      <div
        class="tab-pane coupon_modal_bd"
        v-bind:class="{ active: type === 2 }"
      >
        <!---优惠券列表-->
        <ul v-if="preUsedCoupons.length > 0" class="row coupon__used">
          <li
            v-for="item in usedCoupons"
            :key="item.id"
            class="col-lg-6 used_status"
          >
            <div class="coupon_box fix">
              <div class="f-fl">
                <div class="left_box">
                  <div class="coupon_anchor">
                    <img
                      src="https://resource.rcclchina.com.cn/tui2/user_center/anchor.png"
                    />
                  </div>
                  <div class="coupon_title">
                    {{ item.promotion }}
                    <span class="price"></span>
                  </div>
                  <div v-if="item.createdTime" class="coupon_date">
                    {{item.createdTime}}
                  </div>
                  <div class="coupon_date">
                    {{item.expirationTime}}
                  </div>
                  <div class="coupon_info">
                    <span role="button" @click="showCouponLayer(item.rule)"
                      >使用规则</span
                    >
                    券编号:&nbsp;{{ item.token }}
                  </div>
                </div>
              </div>
              <div class="f-fl">
                <div class="right_box">
                  <a :href="item.skipUrl">
                    <i class="coupon_status"></i>
                  </a>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!--内容为空提示-->
        <div v-else class="isnull_tips">
          <img src="../../assets/no_coupon_ico.png" alt="" />
          好可惜，这里空空如也~<br />
          您目前没有可用优惠券呦！<br />
          <router-link to="/Rccl.Cruise/CruiseSearch/Search" class="go_next_btn"
            >马上去看看</router-link
          >
        </div>
      </div>
      <!--已过期-->
      <div
        class="tab-pane coupon_modal_bd"
        v-bind:class="{ active: type === 3 }"
      >
        <!---优惠券列表-->
        <ul v-if="preExpiredCoupons.length > 0" class="row coupon__useExpired">
          <li
            v-for="item in expiredCoupons"
            :key="item.id"
            class="col-lg-6 expired_status"
          >
            <div class="coupon_box fix">
              <div class="f-fl">
                <div class="left_box">
                  <div class="coupon_anchor">
                    <img
                      src="https://resource.rcclchina.com.cn/tui2/user_center/anchor.png"
                    />
                  </div>
                  <div class="coupon_title">
                    {{ item.promotion }}
                    <span class="price"></span>
                  </div>
                  <div v-if="item.createdTime" class="coupon_date">
                    {{item.createdTime}}
                  </div>
                  <div class="coupon_date">
                    {{item.expirationTime}}
                  </div>
                  <div class="coupon_info">
                    <span role="button" @click="showCouponLayer(item.rule)"
                      >使用规则</span
                    >
                    券编号:&nbsp;{{ item.token }}
                  </div>
                </div>
              </div>
              <div class="f-fl">
                <div class="right_box">
                  <a :href="item.skipUrl">
                    <i class="coupon_status"></i>
                  </a>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!--内容为空提示-->
        <div v-else class="isnull_tips">
          <img src="../../assets/no_coupon_ico.png" alt="" />
          好可惜，这里空空如也~<br />
          您目前没有可用优惠券呦！<br />
          <router-link to="/Rccl.Cruise/CruiseSearch/Search" class="go_next_btn"
            >马上去看看</router-link
          >
        </div>
      </div>
    </div>

    <div class="pagination-box">
      <pagination
        :size="pageSize"
        :total="total"
        :current="pageIndex"
        placement="left"
        @on-change="onPaginationChange"
      ></pagination>
    </div>

    <!-- rule 提示层 -->
    <coupon-alert ref="alert" :text="showText"></coupon-alert>
  </div>
</template>

<script>
import CouponAlert from "./CouponAlert";
import Pagination from "@/components/User/Pagination";
import api from "@/api";

export default {
  name: "CouponList",
  components: {
    CouponAlert,
    Pagination,
  },
  props: {
    isExpired: {
      type: Number,
      default: 1,
    },
  },
  data: () => {
    return {
      coupons: [],
      preCanUseCoupons: [],
      preUsedCoupons: [],
      preExpiredCoupons: [],
      canUseCoupons: [],
      usedCoupons: [],
      expiredCoupons: [],
      type: 1,
      showText: "",
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };
  },
  watch: {
    isExpired(newVal) {
      this.type = newVal;
      this.refresh(newVal, this.paginationConfig.pageNo);
    },
  },
  beforeMount() {
    this.init();
  },
  methods: {
    async init() {

      await this.initList();

    },
    async initList() {
      const userToken = this.$store.state.user.userToken;
			this.$loading.show();
      this.coupons = await this.getAllCoupons(userToken);
			this.$loading.hide();
			if (!this.coupons) this.coupons = [];
      this.preCanUseCoupons = this.coupons.filter(
        (item) => item.canUse === true
      );
      this.preUsedCoupons = this.coupons.filter((item) => item.state === 2);
      this.preExpiredCoupons = this.coupons.filter(
        (item) => item.state === 1 && item.isExpired === true
      );

      // 初始化
      this.canUseCoupons = this.showPage(
        this.preCanUseCoupons,
        this.pageSize,
        this.pageIndex
      );
      this.usedCoupons = this.showPage(
        this.preUsedCoupons,
        this.pageSize,
        this.pageIndex
      );
      this.expiredCoupons = this.showPage(
        this.preExpiredCoupons,
        this.pageSize,
        this.pageIndex
      );

      this.total = this.getLen(this.type);
    },
    changeTab(type) {
      this.type = type;

      // 初始化分页
      this.pageIndex = 1;
      this.total = this.getLen(type);
      this.refresh(type, 1);
    },
    showCouponLayer(text) {
      this.showText = text;
      this.$refs["alert"].show();
    },
    onPaginationChange(page) {
      this.pageIndex = page;
      this.refresh(this.type, page);
    },
    getLen(type) {
      switch (type) {
        case 1:
          return this.preCanUseCoupons.length;
        case 2:
          return this.preUsedCoupons.length;
        case 3:
          return this.preExpiredCoupons.length;
      }
    },
    refresh(type, current) {
      switch (type) {
        case 1:
          this.canUseCoupons = this.showPage(
            this.preCanUseCoupons,
            this.pageSize,
            current
          );
          break;
        case 2:
          this.usedCoupons = this.showPage(
            this.preUsedCoupons,
            this.pageSize,
            current
          );
          break;
        case 3:
          this.expiredCoupons = this.showPage(
            this.preExpiredCoupons,
            this.pageSize,
            current
          );
          break;
      }
    },
    showPage(data, pageSize, pageIndex) {
      return data.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    async getAllCoupons(userToken) {
      const { errMsg, data, success } = await api.user.getAllCoupons(userToken);
      if (success) {
        return data;
      } else {
        window.console.log(errMsg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nav-tabs {
  border: none;
  margin-bottom: -1px;
  li {
    a {
      width: 155px;
      padding: 0;
      margin: 0;
      background-color: #f3f6f8;
      border: solid 1px #d3dadd;
      border-right: none;
      border-radius: 0;
      color: #282b2c;
      text-align: center;
      line-height: 55px;
      i {
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 15px;
        margin-left: 3px;
        border-radius: 50%;
        background: #ff3022;
        color: #fff;
        line-height: 15px;
        font-size: 12px;
      }
    }
    &:last-child {
      a {
        border-right: solid 1px #d3dadd;
      }
      &:hover {
        a {
          border-right: solid 1px #d3dadd;
        }
      }
    }
    &.active {
      a {
        border-right: none;
        border-bottom: none;
        background: #fff;
        color: #006ab9;
        &:after {
          content: "";
          display: block;
          height: 4px;
          background-color: #006ab9;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
        }
      }
      &:last-child {
        a {
          border-right: solid 1px #d3dadd;
        }
      }
    }
    &:hover {
      a {
        border-right: none;
      }
    }
  }
}
.tab-content {
  background-color: #fff;
  box-shadow: 0 0 16px 0 rgba(46, 65, 80, 0.11);
  border: solid 1px #d3dadd;
  min-height: 300px;
  padding: 30px;

  .isnull_tips {
    text-align: center;
    padding: 40px 0;
    font-size: 16px;
    color: #a2adb1;
    line-height: 1.8;
    img {
      display: block;
      margin: 0 auto 20px;
    }
    .go_next_btn {
      display: inline-block;
      line-height: 30px;
      padding: 0 30px;
      border: 1px solid #54a3de;
      color: #54a3de;
      border-radius: 20px;
      margin-top: 30px;
      text-decoration: unset;
    }
  }
  .booking_now {
    margin-top: 10px;
    text-align: center;
    a {
      color: #0073bb;
    }
  }
}

.pagination-box {
  padding: 20px 0;
}

/*优惠券 | 礼品券*/
.coupon_modal_bd .coupon_box {
  color: #051555;
  overflow: hidden;
  margin-bottom: 10px;
}
.coupon_modal_bd .coupon_box .left_box {
  width: 274px;
  height: 97px;
  background: #f8de57;
  border-radius: 5px;
  padding: 0 8px;
  position: relative;
  overflow-x: hidden;
  font-size: 13px;
}

.coupon_modal_bd .coupon_box .left_box .coupon_anchor {
  position: absolute;
  left: -30px;
  top: 0;
}

.coupon_modal_bd .coupon_box .left_box .coupon_title {
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
  margin-bottom: 7px;
  padding-top: 12px;
}
.coupon_modal_bd .coupon_box .left_box .coupon_title .price {
  font-size: 16px;
  margin-left: 10px;
}
.coupon_modal_bd .coupon_box .left_box .coupon_title .price em {
  font-size: 16px;
  font-style: normal;
}
.coupon_modal_bd .coupon_box .left_box .coupon_date {
  line-height: 14px;
  margin-bottom: 5px;
}

.coupon_modal_bd .coupon_box .left_box .coupon_info {
  position: relative;
  z-index: 2;
  line-height: 14px;
}

.coupon_modal_bd .coupon_box .left_box .coupon_info span {
  text-decoration: underline;
  margin-right: 0;
}

.coupon_modal_bd .coupon_box .right_box {
  position: relative;
  width: 120px;
  height: 97px;
  background: #051555;
  border-radius: 5px;
  border-left: 1px dashed #fff;
  cursor: pointer;
}
.coupon_modal_bd .coupon_box .right_box:after,
.coupon_modal_bd .coupon_box .right_box:before {
  position: absolute;
  width: 23px;
  height: 23px;
  content: "";
  background: #fff;
  border-radius: 50%;
  left: -10px;
}
.coupon_modal_bd .coupon_box .right_box:after {
  top: -16px;
}
.coupon_modal_bd .coupon_box .right_box:before {
  bottom: -16px;
}
.coupon_modal_bd .coupon_box .right_box .coupon_status {
  width: 109px;
  height: 85px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -42.5px;
  margin-left: -54.5px;
  background: url(../../assets/conpou_status.jpg) no-repeat;
  display: block;
}
/*可使用*/
.coupon_modal_bd .be_usable_status .right_box .coupon_status {
  background-position: 0px -170px;
}
/*立即使用*/
.coupon_modal_bd .use_now_status .right_box .coupon_status {
  background-position: -218px 0px;
}
/*已领取*/
.coupon_modal_bd .reeceived_status .right_box .coupon_status {
  background-position: -109px 0px;
}

/*已使用*/
.coupon_modal_bd .used_status .left_box {
  background: #f0f0f0;
  color: #999999;
}
.coupon_modal_bd .used_status .right_box {
  cursor: not-allowed;
  background: #cccccc;
}
.coupon_modal_bd .used_status .right_box .coupon_status {
  background-position: 0px -85px;
}
/*已冻结*/
.coupon_modal_bd .frozen_status .left_box {
  background: #f0f0f0;
  color: #98a9bd;
}
.coupon_modal_bd .frozen_status .right_box {
  cursor: not-allowed;
  background: #e5e9ee;
}
.coupon_modal_bd .frozen_status .right_box .coupon_status {
  background-position: -109px -85px;
}
/*已过期*/
.coupon_modal_bd .expired_status .left_box {
  background: #f0f0f0;
  color: #999999;
}
.coupon_modal_bd .expired_status .right_box {
  cursor: not-allowed;
  background: #cccccc;
}
.coupon_modal_bd .expired_status .right_box .coupon_status {
  background-position: -218px -85px;
}
</style>
